export default __webpack_public_path__ + "static/media/25102002.1d9dc312.png";